import { Box, Typography, Link } from "@mui/material";
import whatsapp from "../../../Assets/Whatsapp_vector.png";
import { useSellerOrgConfig } from "../../../Hooks/useSellerOrgConfig";

const Header: React.FC = () => {
  const { branding } = useSellerOrgConfig();
  const hasLogo = Boolean(branding.authHeaderLogo);
  const hasWhatsapp = Boolean(branding.whatsappHref && branding.whatsappDisplay);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 2, sm: 4 },
        height: { xs: 60, sm: 70 },
        backgroundColor: "#FFFFFF",
        borderBottomLeftRadius: "20px",
        borderBottomRightRadius: "20px",
      }}
    >
      {hasLogo ? (
        <Box
          component="img"
          src={branding.authHeaderLogo}
          alt={branding.authHeaderLogoAlt}
          sx={{
            width: { xs: 60, sm: 80, md: 100 },
            height: "auto",
            objectFit: "contain",
          }}
        />
      ) : (
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "text.secondary" }}>
          {branding.authHeaderLogoAlt}
        </Typography>
      )}

      {hasWhatsapp && (
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            maxWidth: { xs: 160, sm: 220, md: 300 },
          }}
        >
          <Box
            component="img"
            src={whatsapp}
            alt="WhatsApp"
            sx={{
              width: { xs: 16, sm: 20 },
              height: { xs: 16, sm: 20 },
              flexShrink: 0,
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: 0.5,
              overflow: "hidden",
              textAlign: { xs: "left", sm: "right" },
              flex: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontSize: { xs: "0.65rem", sm: "0.75rem", md: "0.85rem" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Need Help? Whatsapp
            </Typography>

            <Link
              href={branding.whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "0.65rem", sm: "0.75rem", md: "0.85rem" },
                color: "#25D366",
                textDecoration: "none",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                "&:hover": { textDecoration: "none" },
              }}
            >
              {branding.whatsappDisplay}
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Header;
